module.exports = __webpack_public_path__ + "img/resources-375.46b17ad0.jpg";